import React from 'react'

import { StaticImage } from 'gatsby-plugin-image'

const Hero = ({ showPerson, showPersonPost, customTop }) => {
  return (
    <header className="hero">
      {showPerson && (
        <StaticImage
          src="../assets/person.png"
          placeholder="blurred"
          className="hero-person"
          alt="person typing"
        />
      )}
      {showPersonPost && (
        <StaticImage
          src="../assets/p2.png"
          placeholder="blurred"
          className="hero-person"
          alt="person typing"
        />
      )}
      {customTop && (
        <StaticImage
          src="../assets/p2.png"
          placeholder="blurred"
          className="hero-person"
          alt="person typing"
        />
      )}
    </header>
  )
}

export default Hero
